import { memo } from 'react'
import useSubscription from 'hooks/useSubscription';

const SubscriptionInit = () => {
  useSubscription();

  return null
};

export default memo(SubscriptionInit);